import React from 'react';
import classNames from 'classnames/bind';
import { usePlacesWidget } from 'react-google-autocomplete';
import { appConfig } from 'config/app';
import { Field } from '@odin-labs/components';
import { setRefFactory } from 'components/utils';
import { Place, PlacesAutocompleteProps } from './types';
import { getApiKeyWithCallback } from './utils';
import * as styles from './scss/places-autocomplete.scss';

const cx = classNames.bind(styles);

export const PlacesAutocomplete = React.forwardRef(
  (
    props: PlacesAutocompleteProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ): React.ReactElement => {
    const { onCommit, className, ...rest } = props;

    const onPlaceSelectedHandler = (place: Place): void => {
      onCommit?.(place);
    };

    const { ref: placesInputRef } = usePlacesWidget<HTMLInputElement>({
      apiKey: getApiKeyWithCallback(appConfig.googleMapsApiKey),
      onPlaceSelected: onPlaceSelectedHandler,
      options: {
        // https://developers.google.com/maps/documentation/places/web-service/supported_types#table3
        types: ['geocode', 'establishment'],
        // https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult
        fields: ['address_components', 'formatted_address', 'geometry'],
        componentRestrictions: { country: 'us' },
      },
    });

    const setRef = setRefFactory<HTMLInputElement>({
      innerRef: placesInputRef,
      outerRef: ref,
    });

    return (
      <Field
        {...rest}
        ref={setRef}
        className={cx('places-autocomplete', className)}
      />
    );
  },
);
